import { Card, DataList, Flex, Link, Text } from "@radix-ui/themes";
import React from "react";

export const Footer = () => {
  return (
    <Flex direction={"column"} gap={"6"} className={"mt-48 mb-32"}>
      <Text
        size={"5"}
        weight={"medium"}
        align={"center"}
        style={{
          fontWeight: "600",
          lineHeight: 1.3,
        }}
      >
        여기까지 스크롤을 내려주셔서 감사합니다.
        <br />더 궁금한 점이 있다면 편하게 연락주세요.
      </Text>

      <Card className={"p-8"}>
        <DataList.Root size={"3"}>
          <DataList.Item align="center">
            <DataList.Label minWidth="88px">전화번호</DataList.Label>
            <DataList.Value>
              <Text>01047039091</Text>
            </DataList.Value>
          </DataList.Item>
          <DataList.Item>
            <DataList.Label minWidth="88px">이메일</DataList.Label>
            <DataList.Value>
              <Text>bellman.jang@gmail.com</Text>
            </DataList.Value>
          </DataList.Item>
          <DataList.Item>
            <DataList.Label minWidth="88px">GitLab</DataList.Label>
            <DataList.Value>
              <Link
                href={"https://gitlab.com/henge-inc"}
                target={"_blank"}
                rel={"noopener noreferrer"}
                className={"text-[var(--tomato-9)]"}
              >
                @henge-inc
              </Link>
            </DataList.Value>
          </DataList.Item>
          {/*<DataList.Item>*/}
          {/*  <DataList.Label minWidth="88px">GitHub</DataList.Label>*/}
          {/*  <DataList.Value>*/}
          {/*    <Link*/}
          {/*      href={"https://github.com/Joey-Jang"}*/}
          {/*      target={"_blank"}*/}
          {/*      rel={"noopener noreferrer"}*/}
          {/*      className={"text-[var(--tomato-9)]"}*/}
          {/*    >*/}
          {/*      @Joey-Jang*/}
          {/*    </Link>*/}
          {/*  </DataList.Value>*/}
          {/*</DataList.Item>*/}
        </DataList.Root>
      </Card>
    </Flex>
  );
};
